import React, { useEffect } from 'react';

const Modal = ({ show, title, content, onClose }) => {
    // Закриття модального вікна по Escape
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && show) {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [show, onClose]);

    // // Блокування скролу body при відкритому модальному вікні
    // useEffect(() => {
    //     if (show) {
    //         document.body.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.overflow = 'auto';
    //     }

    //     return () => {
    //         document.body.style.overflow = 'auto';
    //     };
    // }, [show]);

    if (!show) return null;

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('virtual-tour-modal')) {
            onClose();
        }
    };

    return (
        <div className="virtual-tour-modal show" onClick={handleOverlayClick}>
            <div className="modal-content">
                <button className="close" onClick={onClose} />

                <div id="modal-body">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'rgba(0, 0, 0, 0.9)'
                    }}>
                        <h2 style={{ margin: 0 }}>{title}</h2>
                    </div>

                    <div className="modal-content-wrapper">
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
